export const environment = {
  production: false,
  API_URL: 'http://localhost:8080/',
  unsplash: {
    access: '9e220b2df2f9fee1a8198a32e24979d6016baac83262b4e5081235d607774361',
    private: 'c5b07c0304c964dbd518653a20cb54dbe88e7ace3bb750d6a8fc1d64d6e3d440',
  }
};
